import type { PuntosEntregaRepositoryPort } from './ports/PuntosEntregaRepositoryPort.ts';
import type { PuntoEntregaLugarOrigen } from './puntoEntregaLugarOrigen.ts';
import { legacyLugarNombreInComuna } from './puntoEntregaLugarOrigen.ts';

/** Catalog reads for delivery / location display names (forms, PDFs, offline sync wire). */
export type PuntoEntregaCatalogNavigationPort = Pick<
  PuntosEntregaRepositoryPort,
  | 'listEntregas'
  | 'listComunas'
  | 'listBarriosByComuna'
  | 'listLugaresByBarrio'
  | 'listLugaresByComuna'
  | 'findPuntosEntregaCatalogoById'
>;

/** Shell surface for delivery-point FO-GESR PDF metadata. */
export type PuntoEntregaReportPdfShellPort = PuntoEntregaCatalogNavigationPort &
  Pick<PuntosEntregaRepositoryPort, 'listTiposDocumento' | 'findParticipanteById'>;

/**
 * Gets delivery name by id.
 */
export function entregaNombreById(svc: PuntoEntregaCatalogNavigationPort, id: number): string {
  return svc.listEntregas().find((e) => e.id === id)?.nombre ?? '';
}

/**
 * Gets location name by id and origen (avoids catalog/legacy id collisions).
 */
export function lugarNombreByRef(
  svc: PuntoEntregaCatalogNavigationPort,
  id: number,
  origen: PuntoEntregaLugarOrigen | '',
): string {
  if (id <= 0) return '';
  if (origen === 'catalogo') {
    return svc.findPuntosEntregaCatalogoById(id)?.nombre ?? '';
  }
  if (origen === 'legacy') {
    for (const c of svc.listComunas()) {
      const n = legacyLugarNombreInComuna(svc, c.id, id);
      if (n) return n;
    }
    return '';
  }
  return lugarNombreById(svc, id);
}

/**
 * Gets location name by id (prefers catalog when both share numeric id).
 * @deprecated Prefer {@link lugarNombreByRef} when `lugar_origen` is known.
 */
export function lugarNombreById(svc: PuntoEntregaCatalogNavigationPort, id: number): string {
  const catalog = svc.findPuntosEntregaCatalogoById(id);
  if (catalog?.nombre) return catalog.nombre;
  for (const c of svc.listComunas()) {
    for (const b of svc.listBarriosByComuna(c.id)) {
      const n = svc.listLugaresByBarrio(b.id).find((l) => l.id === id)?.nombre;
      if (n) return n;
    }
  }
  return '';
}
